import * as QueryString from "querystringify";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { ComponentWithValidatedForm } from "../../../components/validation";
import { Paths } from "../../../constants";
import * as Forms from "../../../forms";
import { Result } from "../../../models/result";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { AuthHelper } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    api: new Api(state),
    clientId: state.auth.clientId,
    clientSecret: state.auth.clientSecret,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
    onAuthSuccess: (accessToken: string, refreshToken: string) => {
        dispatch(Actions.Auth.postAuthorize(accessToken, refreshToken));
    },
});

type OwnProps = RouteComponentProps<{
    guid: string;
    returnUrl?: string;
}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    clientId: string;
    clientSecret: string;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    notifySuccess: (message: string, icon?: string) => void;
    onAuthSuccess: (accessToken: string, refreshToken: string) => void;
};

interface OwnState {
    loading: boolean;
    noActiveRecord?: boolean;
}

interface CheckPasswordResetResult {
    noActiveRecord: boolean;
}

class ResetPasswordFormComponent extends ComponentWithValidatedForm<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    private _mounted = false;

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.Account.ResetPassword();
        this.state = {
            ...this.getInitialState(formModel),
            loading: true,
        };
    }

    public async componentDidMount() {
        this._mounted = true;

        const qp = { queryParams: { guid: this.props.match.params.guid || "" } };
        const result = await this.props.api.get<CheckPasswordResetResult>(Api.endpoints.account.checkPasswordReset, qp);

        if (!this._mounted)
            return;

        let noActiveRecord = true;

        if (result.isSuccess && result.data) {
            noActiveRecord = result.data.noActiveRecord;
        }
        else
            noActiveRecord = true;

        this.setState({
            ...this.state,
            loading: false,
            noActiveRecord,
        });
    }

    public componentWillUnmount() {
        this._mounted = false;
    }

    public render() {
        const submitButtons = this.state.formProcessing
            ? <div>
                <span className="btn btn-primary" style={{ float: "right" }}>&nbsp;&nbsp;<Comp.Generic.Icon icon="spinner fa-spin" />&nbsp;&nbsp;</span>
            </div>
            : <div>
                <Link className="btn btn-link" to={Paths.Home}>Cancel</Link>
                <input className="btn btn-primary" style={{ float: "right" }} type="submit" value="Submit" />
            </div>;

        const view = this.state.noActiveRecord
            ? <BS.Alert bsStyle="info">
                The request for your password reset is either expired or does not exist.
                <br /><br />
                Return to the <Link to={Paths.Home}><strong>home page</strong></Link> or request a new <Link to={Paths.Account.Login}><strong>password reset</strong></Link>.
            </BS.Alert>
            : <div>
                <Comp.Editors.EmailField formComponent={this} compact css="txt" name="username" />
                <Comp.Editors.PasswordField formComponent={this} compact css="txt" name="password" />
                <Comp.Editors.PasswordField formComponent={this} compact css="txt" name="confirmPassword" />

                {submitButtons}
            </div>;

        return <Comp.Page.SignInPage>
                <div style={{ position: "relative"}}>
                    <Comp.Generic.LoadingSpinner show={this.state.loading} />

                    <Comp.Validation.ValidatedForm
                    formComponent={this}
                    model={this.state.formModel.data}
                    onValidSubmit={async (model) => await this.onSubmit(model)}
                    schema={this.state.formModel.rules}
                    showErrorsOnSubmit={false}
                    ref={(ref) => this.form = ref}
                >
                    <h1>Reset your password</h1>

                    {view}

                </Comp.Validation.ValidatedForm>
            </div>
        </Comp.Page.SignInPage>;
    }

    private getRedirectUrl(): string {
        const queryString = QueryString.parse(this.props.location.search);
        if (queryString["returnUrl"])
            return queryString["returnUrl"];

        return Paths.Home;
    }

    private async onSubmit(model: Forms.Account.ResetPasswordData) {
        this.toggleProcessing(true);

        const result = await this.props.api.post<boolean>(Api.endpoints.account.resetPassword, {
            body: JSON.stringify({
                username: model.username,
                password: model.password,
                confirmPassword: model.confirmPassword,
                guid: this.props.match.params.guid,
            }),
        });

        if (!this._mounted)
            return;

        if (result.isSuccess) {
            // now we need to log in the user
            const authResult = await this.props.api.authorize({
                clientId: this.props.clientId,
                clientSecret: this.props.clientSecret,
                username: model.username,
                password: model.password,
                grantType: "password",
            });

            if (!this._mounted)
                return;

            if (authResult.isSuccess && authResult.data) {
                AuthHelper.saveTokenToCookie(authResult.data.access_token, authResult.data.refresh_token);
                this.props.notifySuccess("Your password has been successfully reset.");
                this.props.onAuthSuccess(authResult.data.access_token, authResult.data.refresh_token);
                this.props.goto(this.getRedirectUrl());
            }
            else {
                this.setFormErrors(Result.errorsOrMessage(authResult));
            }
        }
        else {
            this.setFormErrors(Result.errorsOrMessage(result));
        }

        if (this._mounted)
            this.toggleProcessing(false);
    }
}

export const ResetPasswordForm: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(ResetPasswordFormComponent);



// WEBPACK FOOTER //
// ./src/containers/account/resetPassword/ResetPassword.tsx